import Axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export function UpdateUserService(data, token, userId) {
  return new Promise(async (resolve, reject) => {
    try {
      console.log(data, userId);
      const response = await Axios.put(
        `${URL_AUTH}/api/admin/v1/user/update`,
        data,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response);
    } catch (error) {
      console.log(error);
      reject(error);
    }
  });
}